import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../shared/services/loader.service';
import { MonitorService } from '../shared/monitor.service';
import { Health } from '../shared/health';
import { Metrics } from '../shared/metrics';
import { Subscription, timer } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';

@Component({
  selector: 'app-monitor-status',
  templateUrl: './monitor-status.component.html',
  styleUrls: ['./monitor-status.component.scss', '../monitoring.component.scss']
})
export class MonitorStatusComponent implements OnInit, OnDestroy {

  title = 'CMBL Health';

  health: Health;
  metrics: Metrics;

  loadedHealth  = false;
  loadedMetrics = false;

  refreshStatus: Subscription;

  constructor(
    private monitorService: MonitorService,
    private loader: LoaderService,
    private toastr: ToastrService,
    private errorHandler: ErrorHandlerService,
  ) {

    this.refreshStatus = timer(0, 30000).subscribe(() => {
      this.loadHealth();
      this.loadMetrics();
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.refreshStatus.unsubscribe();
  }

  loadHealth() {
    this.loader.startLoad();
    this.monitorService.health()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(health => {
        this.health = health;

        this.loadedHealth = true;
      }, e => this.errorHandler.handleHttpError(e, 'monitoring.status.errors.load-health'));
  }

  loadMetrics() {
    this.loader.startLoad();

    this.monitorService.metrics()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(metrics => {
        this.metrics = metrics;

        this.loadedMetrics = true;
      }, e => this.errorHandler.handleHttpError(e, 'monitoring.status.errors.load-metrics'));
  }

}
